<template>
  <div>
    <div v-if="currentSearchResultTab === 'all'">
      <div v-if="searchResultMultiSectionList && searchResultMultiSectionList.length" class="search-result-multi-band-container">
        <div v-for="(sectionInfo, index) in searchMultiSectionList" :key="sectionInfo.title + index" class="multi-section-container">
          <DynamicSectionLoader :section-info="sectionInfo" :key="sectionInfo.title" :keyword="keyword"></DynamicSectionLoader>
        </div>
      </div>
      <div class="recent-keyword-empty" v-if="searchResultMultiSectionList.length === 0">
        <div class="attention-mark-area">
          <div class="icon">
            <EmptyIcon />
          </div>
        </div>
        <div class="info-text">
          <span class="dark-purple">'{{getClampText(lastKeyword, 30)}}'</span> 검색결과가 없어요.<br/>
          <span v-if="changeKeyword === ''">
          이런 검색어는 어떠세요?
          </span>
          <span v-else>
            혹시 "{{changeKeyword}}" 찾으시나요?
          </span>
        </div>
        <a class="btn-research" v-if="changeKeyword !== ''" @click.prevent="reSearchByFixedKeyword">
          <span>'{{changeKeyword}}' 재검색</span>
          <CircleArrowBlueIcon />
        </a>
        <div class="recommend-keyword-list">
          <span v-for="(keywordItem) in keywordList"
                :key="'empty-keyword' + keywordItem.text"
                @click.prevent="()=>moveToRecommendTag(keywordItem)"
                class="tag-item">
            {{keywordItem.text}}
          </span>
        </div>
      </div>
    </div>
    <div v-if="currentSearchResultTab !== 'all'">
      <search-result-list :type="currentSearchResultTab" :keyword="keyword"></search-result-list>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
import SearchResultList from '@/components/search/SearchResultList'
import { SearchService } from '@/common/api/api.service'
import EmptyIcon from '@/assets/svg/common/img_empty.svg'
import CircleArrowBlueIcon from '@/assets/svg/common/ic-research-blue.svg'
import { parse } from 'query-string'
import { get } from 'lodash'
import { getClampText } from '@/common/util/text.utils'

export default {
  name: 'SearchResultBandView',
  components: {
    DynamicSectionLoader,
    SearchResultList,
    EmptyIcon,
    CircleArrowBlueIcon
  },
  props: ['keyword', 'changeKeyword', 'lastKeyword', 'searchByChangeKeyword'],
  data () {
    return {
      keywordList: [],
      recentKeyword: ''
    }
  },
  methods: {
    ...mapMutations(['changeTab', 'setExternalInputSearchKeyword', 'resetSearchState', 'deleteAllTag', 'hideSearchResult']),
    getClampText: getClampText,
    whenEmptyRecentTagThenSetData () {
      SearchService.getRecommendSearchKeywordList().then(({ data }) => {
        this.keywordList = Object.assign([], data).splice(0, 5)
      })
    },
    moveToRecommendTag (keywordItem) {
      const uiCode = get(parse(keywordItem.link.split('?').pop()), 'uicode', '')
      if (uiCode !== '') {
        this.$router.push({ name: 'searchList', params: { uiCode: uiCode, section: uiCode } })
      } else {
        this.$router.replace(keywordItem.link.replace('captvpooq://', '').replace('https://m.pooq.co.kr', '')).replace('https://m.wavve.com', '')
      }
    },
    reSearchByFixedKeyword () {
      this.searchByChangeKeyword()
    }
  },
  computed: {
    ...mapGetters(['searchResultMultiSectionList', 'currentSearchResultTab']),
    searchMultiSectionList () {
      return this.searchResultMultiSectionList.filter(list => list.title !== 'TV컷')
    }
  },
  created () {
    this.whenEmptyRecentTagThenSetData()
    this.recentKeyword = this.keyword
  }

}
</script>

<style scoped>
  .search-result-multi-band-container {
    /*overflow-scrolling: touch;*/
    /*-webkit-overflow-scrolling: touch;*/
    /*overflow-y: scroll;*/
    background-color: #1b1b1b;
  }
  .search-result-multi-band-container::-webkit-scrollbar{
    display: none;
    background-color: transparent
  }
  .recent-keyword-empty {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 72px;
  }
  .attention-mark-area .icon {
    position: relative;
    width: 50px;
    height: 50px;
    margin: 0 auto;
  }
  .info-text {
    margin-top: 16px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #a5a5a5;
  }
  .recommend-keyword-list {
    position: relative;
    top: 50px;
    width: 100%;
    padding: 0 5px 0 5px;
    height: 190px;
    text-align: center;
  }
  .tag-item {
    z-index: 100;
    display: inline-block;
    position: relative;
    top: 10px;
    min-width: 61px;
    margin: 10px 10px 0 0;
    padding: 5px 10px;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    color: #a5a5a5;
    border: 1px solid #b4b4b4;
    -moz-border-radius: 16px 16px 16px 16px;
    border-radius: 16px 16px 16px 16px;
  }
  .btn-research {
    display: block;
    margin-top: 40px;
    font-size: 12px;
    line-height: 18px;
    color: #a5a5a5;
    text-align: center;
  }
  .btn-research span,
  .btn-research svg{
    vertical-align: middle;
  }
  .btn-research > svg{
    width: 18px;
    line-height: 18px;
  }
  .btn-research span + svg{
    margin-left: 4px;
  }
</style>
